<template>
    <v-card class="pa-2 pl-md-10 app-screen-bg rules-page" >
        <v-card-text class="rules-page__body">
            <div class="rules-title-pill-wrap">
                <span class="rules-title-pill">{{ $t('dashboard.gameRules.titlePill') }}</span>
            </div>
            <v-card class="rules-content-card">
                <v-card-text>
                <div class="rules-intro-section">
                    <p class="ma-0">
                        {{ $t('dashboard.gameRules.intro') }}
                    </p>
                </div>
                <v-expansion-panels>

                    <v-expansion-panel
                        :key="1"
                    >
                        <v-expansion-panel-header class="rules-panel-header">
                            <span class="rules-panel-title">{{ $t('dashboard.gameRules.panels.p1Header') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>

                            <h3>{{ $t('dashboard.gameRules.panel1.goal.title') }}</h3>
                            <img src="@/assets/pic/rules/badges.png" class="rules-badges-img">
                            <div v-html="$t('dashboard.gameRules.panel1.goal.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel1.howTo.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel1.howTo.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel1.controls.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel1.controls.body')"></div>

                            <!--
                            <h3>{{ $t('dashboard.gameRules.panel1.macko.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel1.macko.body')"></div>
                            -->
                        </v-expansion-panel-content>

                    </v-expansion-panel>

                    <v-expansion-panel
                        :key="2"
                    >
                        <v-expansion-panel-header class="rules-panel-header">
                            <span class="rules-panel-title">{{ $t('dashboard.gameRules.panels.p2Header') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <img src="@/assets/pic/rules/screenshot-pokedex.png" class="rules-screenshot" alt="Pokedex">
                            <div v-html="$t('dashboard.gameRules.panel2.intro')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel2.levels.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel2.levels.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel2.types.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel2.types.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel2.hp.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel2.hp.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel2.specialAttacks.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel2.specialAttacks.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel2.evolutions.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel2.evolutions.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel2.healing.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel2.healing.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel2.catching.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel2.catching.body')"></div>
                            <v-btn color="warning" class="black--text" @click="catchOddsOpen = true">
                                <v-icon left>mdi-help-circle</v-icon>
                                {{ $t('dashboard.gameRules.buttons.catchOdds') }}
                            </v-btn>

                            <CatchOddsDialog v-model="catchOddsOpen"/>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel
                        :key="3"
                    >
                        <v-expansion-panel-header class="rules-panel-header">
                            <span class="rules-panel-title">{{ $t('dashboard.gameRules.panels.p3Header') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-html="$t('dashboard.gameRules.panel3.intro')"></div>

                            <h3>{{ $t('dashboard.gameRules.common.calculation.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.common.calculation.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel3.effects.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel3.effects.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel3.trainerFight.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel3.trainerFight.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel3.ineffectiveDefense.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel3.ineffectiveDefense.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel3.types.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel3.types.body')"></div>

                            <v-btn color="warning" class="black--text" @click="typeChartOpen = true">
                                <v-icon left>mdi-sword-cross</v-icon>
                                {{ $t('dashboard.gameRules.buttons.typeChart') }}
                            </v-btn>
                            <v-btn color="warning" class="black--text ml-2" @click="typeMatrixOpen = true">
                                <v-icon left>mdi-table-large</v-icon>
                                {{ $t('dashboard.gameRules.buttons.typeMatrix') }}
                            </v-btn>

                            <TypeChartDialog v-model="typeChartOpen"/>
                            <TypeMatrixDialog v-model="typeMatrixOpen"/>

                            <h3>{{ $t('dashboard.gameRules.panel3.terrain.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel3.terrain.body')"></div>

                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel
                        :key="4"
                    >
                        <v-expansion-panel-header class="rules-panel-header">
                            <span class="rules-panel-title">{{ $t('dashboard.gameRules.panels.p4Header') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <img src="@/assets/pic/rules/screenshot-trainer.png" class="rules-screenshot" :alt="$t('dashboard.gameRules.images.trainerScreenshotAlt')">
                            <div v-html="$t('dashboard.gameRules.panel4.intro')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel4.skills.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel4.skills.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.common.calculation.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.common.calculation.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel4.achievements.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel4.achievements.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel4.otherPlayers.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel4.otherPlayers.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel4.cpNcp.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel4.cpNcp.body')"></div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel
                        :key="5"
                    >
                        <v-expansion-panel-header class="rules-panel-header">
                            <span class="rules-panel-title">{{ $t('dashboard.gameRules.panels.p5Header') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>{{ $t('dashboard.gameRules.common.oak.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.common.oak.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel5.rocket.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel5.rocket.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel5.jenny.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel5.jenny.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel5.pokecenter.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel5.pokecenter.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel5.stadium.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel5.stadium.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel5.obstacle.title') }}</h3>
                            <img src="@/assets/pic/rules/screenshot-obstacle.png" class="rules-screenshot" :alt="$t('dashboard.gameRules.images.obstacleScreenshotAlt')">
                            <div v-html="$t('dashboard.gameRules.panel5.obstacle.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel5.dungeon.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel5.dungeon.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel5.dungeonChallenge.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel5.dungeonChallenge.body')"></div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel
                        :key="6"
                    >
                        <v-expansion-panel-header class="rules-panel-header">
                            <span class="rules-panel-title">{{ $t('dashboard.gameRules.panels.p6Header') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>{{ $t('dashboard.gameRules.panel6.rules.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel6.rules.body')"></div>

                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel
                        :key="7"
                    >
                        <v-expansion-panel-header class="rules-panel-header">
                            <span class="rules-panel-title">{{ $t('dashboard.gameRules.panels.p7Header') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>{{ $t('dashboard.gameRules.common.oak.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.common.oak.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel7.travelSkills.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel7.travelSkills.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel7.evolveStones.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel7.evolveStones.body')"></div>
                            <StonePowerRankLegend/>

                            <h3>{{ $t('dashboard.gameRules.panel7.pokeballs.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel7.pokeballs.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel7.masterballs.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel7.masterballs.body')"></div>

                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel
                        :key="8"
                    >
                        <v-expansion-panel-header class="rules-panel-header">
                            <span class="rules-panel-title">{{ $t('dashboard.gameRules.panels.p8Header') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-html="$t('dashboard.gameRules.panel8.intro')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel8.challenge.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel8.challenge.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel8.howItWorks.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel8.howItWorks.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel8.whatCounts.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel8.whatCounts.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel8.stats.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel8.stats.body')"></div>

                            <h3>{{ $t('dashboard.gameRules.panel8.ranked.title') }}</h3>
                            <div v-html="$t('dashboard.gameRules.panel8.ranked.body')"></div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                </v-expansion-panels>
                </v-card-text>
            </v-card>
        </v-card-text>

    </v-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import TypeChartDialog from '@/components/dashboard/TypeChartDialog';
    import TypeMatrixDialog from '@/components/dashboard/TypeMatrixDialog';
    import CatchOddsDialog from '@/components/dashboard/CatchOddsDialog';
    import StonePowerRankLegend from '@/components/utils/StonePowerRankLegend';

    export default {
        components: {TypeChartDialog, TypeMatrixDialog, CatchOddsDialog, StonePowerRankLegend},
        data() {
            return {
                typeChartOpen: false,
                typeMatrixOpen: false,
                catchOddsOpen: false,
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'dashboard/isLoading',
                user:  'dashboard/user',
            }),
        },
        watch: {
        },
        methods: {
            ...mapActions({
                getUser: 'dashboard/loadUser',
            }),
        },
    }
</script>

<style scoped>
    /* Flex retezec (rules-page -> rules-page__body -> rules-content-card, kazdy "flex: 1 1 auto") protahne bilou kartu na celou dostupnou vysku */
    .rules-page {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    /* "position: sticky" primo uvnitr scrollovaci oblasti (rules-page__body), ne flex sourozenec mimo ni - viz claude/architecture/frontend.md bod 8 */
    .rules-title-pill-wrap {
        position: sticky;
        top: 0;
        z-index: 3;
        display: flex;
        justify-content: center;
        padding: 8px 0;
        background: transparent;
    }

    .rules-title-pill {
        display: inline-block;
        background: rgba(0, 0, 0, .7);
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        padding: 6px 20px;
        border-radius: 20px;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, .6);
    }

    .rules-intro-section {
        background: rgba(0, 0, 0, .04);
        border: 1px solid rgba(0, 0, 0, .08);
        border-radius: 8px;
        padding: 12px 16px;
        margin-bottom: 16px;
        font-style: italic;
    }

    .rules-page__body {
        /* v-card-text ma vlastni vychozi padding, scital by se s "pa-2" na rodici - vynulovano, "pa-2"/"pl-md-10" na rules-page je jediny zdroj odsazeni */
        padding: 0;
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
    }

    .rules-content-card {
        max-width: 900px;
        width: 100%;
        margin: 0 auto;
        flex: 1 1 auto;
    }

    .rules-panel-header {
        text-align: center;
    }

    .rules-panel-title {
        display: inline-block;
        font-size: 1.15rem;
        font-weight: 500;
        line-height: 1.4;
    }

    .rules-badges-img {
        float: right;
        width: 40%;
        max-width: 220px;
        margin-left: 12px;
        margin-bottom: 8px;
    }

    @media (max-width: 600px) {
        .rules-badges-img {
            float: none;
            display: block;
            width: 60%;
            max-width: 160px;
            margin: 0 auto 12px;
        }
    }

    .rules-screenshot {
        display: block;
        width: 100%;
        max-width: 480px;
        margin: 12px auto;
        border-radius: 14px;
        box-shadow: 0 4px 14px rgba(0, 0, 0, .25);
        border: 3px solid #fff;
    }
</style>

